// Loudspeaker: a coin sink. Pay coins and one line goes to everyone online, as a banner across the top
// of every screen and a highlighted line in World. It goes through the same spam gate and hate filter as chat.

export const LOUD = {
  /** Coins burned per shout (pokeidle charges 10M). */
  cost: 10_000_000,
  /** Trainer level needed, the same as messaging strangers. */
  minLevel: 10,
  maxLen: 120,
  /** One shout per trainer this often. */
  perTrainerMs: 10 * 60_000,
  /** One shout on the air at a time: the next one waits until this long after the last. */
  gapMs: 60_000,
  /** How long the banner stays up. */
  showMs: 15_000,
} as const;

/** Why this trainer can't shout now (null when they can). Coins are checked by the caller. */
export function loudWait(now: number, last: { all: number; mine: number }): string | null {
  const mine = last.mine + LOUD.perTrainerMs - now;
  if (mine > 0) return `Your next Loudspeaker is in ${Math.ceil(mine / 60_000)} min.`;
  const all = last.all + LOUD.gapMs - now;
  if (all > 0) return `Someone is on the Loudspeaker. Try again in ${Math.ceil(all / 1000)} s.`;
  return null;
}
